import Vue from 'vue';
import Component from 'vue-class-component';
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import SelectOption from "@/components/common/SelectOption";
import { PRILStatus } from "@/constants/request/PRILConstants";
import { prettyEnum } from "@/utils/StringUtils";

@Component
export default class PRILExtension extends Vue {

  getDictionaryTitle(dictionary: PortalDictionaryDTO): string {
    if (!dictionary) return ""
    return (this.$i18n.locale === 'en' ? dictionary.valueEn : dictionary.valueRu) || dictionary.name;
  }

  get buildStatuses(): Array<SelectOption> {
    return Object.values(PRILStatus).map(status => SelectOption.builder().title(prettyEnum(status)).value(status).build());
  }

}
